export const roundScalarOfMinAndMaxNumbers = (min: number, max: number) => {
  let roundedMin;
  let roundedMax;
  const minBeforeKomma = ((min + "").split(".")[0] + "").split("");
  const maxBeforeKomma = ((max + "").split(".")[0] + "").split("");
  const minBeforeKommaFlipped = minBeforeKomma.reverse();
  const maxBeforeKommaFlipped = maxBeforeKomma.reverse();

  // get the first digid fefore the komma (counted from komma backwards) that is different between min and max
  const firstDifferentNumberBeforeKomma = minBeforeKommaFlipped.findIndex((_digit, ind) => {
    return minBeforeKommaFlipped[ind] !== maxBeforeKommaFlipped[ind];
  });
  if (firstDifferentNumberBeforeKomma === 0) {
    // if the first digid before the komma is already different, then show 2 digid behind the komma
    const tenFold = Math.pow(10, 2);
    roundedMin = Math.round(min * tenFold) / tenFold;
    roundedMax = Math.round(max * tenFold) / tenFold;
  } else if (firstDifferentNumberBeforeKomma === 1) {
    // if the second digid before the komma is different, then show 1 digid behind the komma
    const tenFold = 10;
    roundedMin = Math.round(min * tenFold) / tenFold;
    roundedMax = Math.round(max * tenFold) / tenFold;
  } else if (firstDifferentNumberBeforeKomma >= 2) {
    // if a later digit then the second digid before the komma is different, then round to a whole number (integer)
    roundedMin = Math.round(min);
    roundedMax = Math.round(max);
  } else {
    // if actually all digids before the komma are equal, then we check if the digids behind the komma are different
    const minBehindKomma = ((min + "").split(".")[1] + "").split("");
    const maxBehindKomma = ((max + "").split(".")[1] + "").split("");
    const firstDifferentNumberBehindKomma = minBehindKomma.findIndex((_digit, ind) => {
      return minBehindKomma[ind] !== maxBehindKomma[ind];
    });
    if (firstDifferentNumberBehindKomma) {
      // if the first digid behind the komma that is different is found then round 2 digids after it (the +1 is the off by one index)
      const tenFold = Math.pow(10, firstDifferentNumberBehindKomma + 1 + 2);
      roundedMin = Math.round(min * tenFold) / tenFold;
      roundedMax = Math.round(max * tenFold) / tenFold;
    } else {
      // else (if the first digid behind the komma that is different is NOT found) just show the whole number ...
      roundedMin = min;
      roundedMax = max;
    }
  }
  return { min: roundedMin, max: roundedMax };
};
